<template>
  <v-container>
    <v-card
      color="#efefef"
      class="ma-0 mb-5"
    >
      <scelta-lenti
        :alive="$options.surname ==='GRV' && $options.name === `Step${step}`"
        :order="order"
        @lensComplete="lensComplete"
      />
    </v-card>
    <v-btn
      color="primary"
      :disabled="!formValidate"
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import SceltaLenti from '../SceltaLentiGrv.vue'
  // import grvengine from '@/plugins/grvengine'

  export default {
    name: 'Step2',
    surname: 'GRV',
    components: {
      SceltaLenti,
    },
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        steporder: {},
        formValidate: false,
        itemsRifrazione: [],
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {
      step (newVal, oldVal) {
        console.log('load', this.$options.name)
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     // console.log('Order changed  in step2 from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      console.log('mount', this.$options.name)
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          this.steporder = Object.assign({}, this.order)
          this.formValidate = !!this.steporder.lens
        }
      },
      lensComplete (lens) {
        if (!lens) {
          this.formValidate = false
          return
        }
        console.log('lensComplete', lens)
        this.steporder.lens = JSON.parse(JSON.stringify(lens))
        this.formValidate = true
      },

      nextStep () {
        // if (this.step > this.steporder.step) { this.steporder.step = this.step }
        // this.$store.commit('setOrder', this.steporder)
        // this.$emit('nextStep', this.step + 1)
        if (this.steporder.monsmo === '//S') {
          // this.$set(this.steporder, 'lens', null)
          if (this.step > this.steporder.step) { this.steporder.step = this.step + 2 }
          this.$store.commit('setOrder', this.steporder)
          this.$emit('nextStep', this.step + 2)
        } else {
          // if (this.step > this.steporder.step) { this.steporder.step = this.step }
          console.log('steporder', this.steporder, this.step)
          this.$store.commit('setOrder', this.steporder)
          this.$emit('nextStep', this.step + 1)
        }
      },
      prevStep () {
        // console.log('prevStep', this.steporder)
        this.$emit('prevStep', this.step)
      },
    },
  }
</script>
